import type { ReactNode } from "react"
import { useEventLoading } from "src/contexts/LoadingContexts"

export interface Props {
  children?: ReactNode;
}

export function UserEventsLoadedComponent(props: Props) {
  const { loaded } = useEventLoading()

  if (!loaded) {
    return null
  }

  return (
    <>
      {props.children}
    </>
  )
}
